export default __webpack_public_path__ + "static/media/87.ce4e0587.jpg";